module.exports = __webpack_public_path__ + "img/icon_category.3e7e5b37.svg";